module.exports = __webpack_public_path__ + "static/media/team-introduction-6.f3d2fd6f.jpg";